import React from 'react';
import type { Goals } from '../../../../../common/types';
import { splitGoals } from '../../../../../common/utils/goal';
import { GoalView } from './goal';

type Props = {
	goals: Goals;
};

export const GoalListView = ({ goals }: Props) => {
	const { defaultGoals, draggableGoals } = splitGoals(goals);
	return (
		<>
			{draggableGoals.map((goal) => (
				<GoalView key={goal.id} goal={goal} />
			))}
			{defaultGoals.map((goal) => (
				<GoalView key={goal.id} goal={goal} />
			))}
		</>
	);
};
